import * as React from "react";
import { QuantitySelector } from "@grandvisionhq/common";
import { getCalculatedMaximumQuantity } from "@grandvisionhq/utils";
import { useUpdateLineItemQuantity } from "../../../../../../hooks/hooks/use-update-line-item-quantity.js";
import { useCartSettings } from "../../../../../../context/CartSettings/context/CartSettings/context.js";
const UpdateLineItemContainer = ({
  lineItem,
  availableQuantity,
  isDisabled
}) => {
  const { minimumQuantity, maximumQuantity } = useCartSettings();
  const [updateItemQuantity] = useUpdateLineItemQuantity(lineItem);
  const handleDecreaseQuantity = React.useCallback(() => {
    updateItemQuantity(lineItem.quantity - 1);
  }, [lineItem.quantity, updateItemQuantity]);
  const handleIncreaseQuantity = React.useCallback(() => {
    updateItemQuantity(lineItem.quantity + 1);
  }, [lineItem.quantity, updateItemQuantity]);
  return /* @__PURE__ */ React.createElement(
    QuantitySelector,
    {
      onDecreaseQuantity: handleDecreaseQuantity,
      onIncreaseQuantity: handleIncreaseQuantity,
      minimumQuantity,
      maximumQuantity: getCalculatedMaximumQuantity(
        maximumQuantity,
        availableQuantity,
        lineItem.allowBackOrder
      ),
      quantity: lineItem.quantity,
      isDisabled,
      "data-t": "quantity-selector",
      disableAnimation: true
    }
  );
};
export {
  UpdateLineItemContainer
};
//# sourceMappingURL=UpdateLineItemContainer.js.map
